import { render, staticRenderFns } from "./EditProvince.vue?vue&type=template&id=32afc680&scoped=true"
import script from "./EditProvince.vue?vue&type=script&lang=js"
export * from "./EditProvince.vue?vue&type=script&lang=js"
import style0 from "./EditProvince.vue?vue&type=style&index=0&id=32afc680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32afc680",
  null
  
)

export default component.exports